//@flow

export type DataFormatType = $Keys<typeof dataFormatTypes>;
export const dataFormatTypes = { absolut: "absolut", percentage: "percentage" };